import { CmsComponentMapping, CmsDefaultComponent } from '@domgen/dgx-fe-cms';
import { CheckoutComponent } from '@us-registration/feature-checkout';
import { ProtectionDetailsComponent } from '@us-registration/feature-protection-details';
import { RegistrationConfirmationComponent } from '@us-registration/feature-registration-confirmation';
import { RegistrationOrderConfirmationComponent } from '@us-registration/feature-registration-order-confirmation';
import { ApplianceDetailsSteppedWibComponent } from 'libs/us-registration/feature-appliance-details-stepped-wib/src';
import { ApplianceDetailsSteppedComponent } from 'libs/us-registration/feature-appliance-details-stepped/src';
import { ProtectionDetailsWibComponent } from 'libs/us-registration/feature-protection-details-wib/src';
import { RegistrationConfirmationWibComponent } from 'libs/us-registration/feature-registration-confirmation-wib/src/lib/pages/registration-confirmation-wib/registration-confirmation-wib.component';
import { RegistrationOrderConfirmationWibComponent } from 'libs/us-registration/feature-registration-order-confirmation-wib/src/lib/pages/registration-order-confirmation-wib/registration-order-confirmation-wib.component';

export const APPLIANCE_REGISTRATION_CMS_COMPONENT_US_MAPPING: CmsComponentMapping =
  {
    'dgx-registration:pages/registration-application': CmsDefaultComponent,
    'dgx-registration:pages/appliance-details-stepped-us-wib':
      ApplianceDetailsSteppedWibComponent,
    'dgx-registration:pages/appliance-details-stepped-us':
      ApplianceDetailsSteppedComponent,
    'dgx-registration:pages/protection-details-us-wib':
      ProtectionDetailsWibComponent,
    'dgx-registration:pages/protection-details-us': ProtectionDetailsComponent,
    'dgx-registration:pages/registration-confirmation-us-wib':
      RegistrationConfirmationWibComponent,
    'dgx-registration:pages/registration-confirmation-us':
      RegistrationConfirmationComponent,
    'dgx-registration:pages/registration-order-confirmation-us-wib':
      RegistrationOrderConfirmationWibComponent,
    'dgx-registration:pages/registration-order-confirmation-us':
      RegistrationOrderConfirmationComponent,
    'dgx-registration:pages/checkout-us': CheckoutComponent,
  };
